import React from 'react';
import Directory from './components/Directory';
import FAQ from './components/FAQ';
import FeatureGrid from './components/FeatureGrid';
import Hero from './components/Hero';
import PrivacyPolicy from './components/PrivacyPolicy';
import Process from './components/Process';
import Resources from './components/Resources';
import './App.css';
import './branding.css';

const runningIconUrl =
  'https://media-manager-c.questera.ai/greta-media/e5cbcfc2bc2cf3629d5039f7c228101dda97897b6d852fa2cbf87118d13cfa9db41510041373b84415dd6e0f3c4fa388/images/aW1hZ2UvcG5n/abf6ffc3b853ff409812dcd97ee41516.png';

function RunningLogo() {
  return (
    <span className="site-brand-icon running-logo" aria-hidden="true">
      <span
        className="running-logo-figure"
        style={{ '--running-icon': `url("${runningIconUrl}")` }}
      />
    </span>
  );
}

function App() {
  if (window.location.pathname === '/privacy-policy') {
    return <PrivacyPolicy />;
  }

  return (
    <div className="app">
      <header className="site-header">
        <a className="site-brand" href="/" aria-label="PTA Programs Orlando">
          <RunningLogo />
          <span>PTA Programs Orlando</span>
        </a>
      </header>
      <Hero />
      <main>
        <Directory />
        <FeatureGrid />
        <Process />
        <FAQ />
      </main>
      <Resources />
    </div>
  );
}

export default App;